export type DataType =
  | "ID"
  | "Text"
  | "Resource"
  | "Source"
  | "Date"
  | "Boolean";

const fieldList = [
  {
    fieldName: "action",
    dataType: "Text",
    isSortable: true,
  },
  {
    fieldName: "expression",
    dataType: "ID",
    isSortable: true,
  },
  {
    fieldName: "resource",
    dataType: "Resource",
    isSortable: true,
  },
  {
    fieldName: "source",
    dataType: "Source",
    isSortable: true,
  },
  {
    fieldName: "expires",
    dataType: "Date",
    isSortable: true,
    orderField: "expiration",
  },
  {
    fieldName: "created",
    dataType: "Date",
    isSortable: true,
  },
  {
    fieldName: "policyId",
    dataType: "ID",
    isSortable: true,
    orderField: "id",
  },
  {
    fieldName: "cascades",
    dataType: "Boolean",
    isSortable: true,
  },
  {
    fieldName: "shareable",
    dataType: "Boolean",
    isSortable: true,
  },
  {
    fieldName: "scope",
    dataType: "Text",
    isSortable: true,
  },
] as const;

export type FieldName = (typeof fieldList)[number]["fieldName"];

export type Fields = {
  [FieldName in (typeof fieldList)[number]["fieldName"]]: Extract<
    (typeof fieldList)[number],
    { fieldName: FieldName }
  >;
};

export type Field = Fields[keyof Fields];

export type ResourceField<ResourceType extends object> = {
  fieldName: keyof ResourceType;
} & Field;

export type FieldLabels<ResourceType extends object> = {
  [FieldName in keyof ResourceType &
    (typeof fieldList)[number]["fieldName"]]: string;
};

const _fields = {} as Record<keyof Fields, Field>;
for (const field of fieldList) {
  _fields[field.fieldName] = field;
}
export const fields = _fields as Fields;

export function isKnownField(fieldName: string): fieldName is keyof Fields {
  return fieldName in fields;
}

export const defaultFieldLabels = {
  action: "Action",
  expression: "Expression",
  resource: "Resource",
  source: "Granted via",
  expires: "Expires",
  created: "Granted on",
  policyId: "Policy ID",
  cascades: "Cascades",
  shareable: "Shareable",
  scope: "Scope",
} as const;

export function getDefaultSortOrder(field: Field): "asc" | "desc" {
  switch (field.dataType) {
    case "Date":
      return "desc";
    default:
      return "asc";
  }
}

export const defaultSortField = fields.created;
